import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GlobalButtonComponent, buttonItem } from '../global-button/global-button.component';
import { ContainerComponent } from '../container/container.component';
import { PictureComponent } from '../picture/picture.component';

export interface SurveyCardStat {
  icon: string;        // Name of SVG icon file
  iconMobile?: string; // Optional mobile icon name
  altText?: string;
  text: string;        // Description text
}

export interface SurveyCardData {
  themeColor: 'cyan' | 'purple' | 'orange'; // styling class
  title: string;       // E.g. "What is stopping you from screening?"
  
  // Left Column (Image)
  imageName?: string;  // File name under /assets/img/survey/, e.g. 'steve.png'
  imageAlt?: string;
  
  // Right Column (Quote)
  quoteText: string;
  quoteAuthor: string;
  quoteAuthorSub?: string;

  // Stat / Fact boxes
  stats: SurveyCardStat[];

  // Bottom text & CTA button
  bottomDescription?: string;
  button?: buttonItem;
}

@Component({
  selector: '[survey-card]',
  standalone: true,
  imports: [CommonModule, GlobalButtonComponent, ContainerComponent, PictureComponent],
  templateUrl: './survey-card.component.html',
  styleUrl: './survey-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyCardComponent {
  @Input({ required: true }) data!: SurveyCardData;

  getImageBaseName(fileName: string | undefined): string {
    if (!fileName) return '';
    const lastDot = fileName.lastIndexOf('.');
    return lastDot === -1 ? fileName : fileName.substring(0, lastDot);
  }

  getImageExtension(fileName: string | undefined): string {
    if (!fileName) return '';
    const lastDot = fileName.lastIndexOf('.');
    return lastDot === -1 ? '' : fileName.substring(lastDot + 1);
  }
}
